import { Injectable, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { pricingSegmentData } from '../../../segment-data/pricing-segment-data';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';
import CurrencyCodeMapper from 'utils/currency-code-mapper';
import { pipe } from 'rxjs';


@Injectable()
export class PricingScorecardService {

  activePriceTypes: Array<any> = [];
  invalidPriceTypes: Array<any> = [];
  priceTypesWithValue: Array<any> = [];
  dropdownPriceTypes: Array<any> = [];
  selectedPriceSheet: any;
  primaryPriceSheet: any;
  private pathToScore: string = 'segments.prices.tallies';

  get selectedPriceSheetNumber(): string {
    return _.get(this.selectedPriceSheet, 'price_sheet_number');
  }

  get selectedPriceSheetName(): string {
    return _.get(this.selectedPriceSheet, 'price_sheet_name');
  }

  get primaryPriceSheetNumber(): string {
    return _.get(this.primaryPriceSheet, 'price_sheet_number');
  }

  separatePriceTypes(itemDetail: any, scoreData: any): void {
    const groups = _.groupBy(pricingSegmentData, ['show_more', true]);
    // 5 default price types + price types with filled values
    this.activePriceTypes = _.cloneDeep(groups['true']);

    // dropdown contains show_more: false items
    // and items which exists in the scorecard
    let otherPriceTypes = _.chain(groups['false'])
    .cloneDeep()
    .map((item: any) => {
      item.option = item.item_name;
      item.title = item.title;
      return item;
    }).value();

    this.priceTypesWithValue = [];

    // Get price types with values
    _.forEach(itemDetail.prices, (pricing: any, priceSheetName: string) => {
      _.forEach(otherPriceTypes, (item: any) => {
        _.some(CurrencyCodeMapper.getCurrencyList(), (currency: any) => {
          const alreadyActive = _.size(_.filter(this.activePriceTypes, { 'item_name': item.item_name }));
          if (_.get(itemDetail, `prices.${priceSheetName}.${item.item_name}.${currency.code}.price`) && !alreadyActive) {
            this.priceTypesWithValue.push(item);
          }
        });
      });
    });

    this.activePriceTypes = _.uniq(_.concat(this.activePriceTypes, this.priceTypesWithValue));

    // Get all scorecard pricetypes
    if (_.size(scoreData)) {
      _.forEach(otherPriceTypes, (item: any) => {
        _.some(CurrencyCodeMapper.getCurrencyList(), (currency: any) => {
          const alreadyActive = _.size(_.filter(this.activePriceTypes, { 'item_name': item.item_name }));

          if (_.has(scoreData, `${this.pathToScore}.${this.primaryPriceSheetNumber}.${item.item_name}.${currency.code}`)
              && !alreadyActive) {
            this.activePriceTypes.push(item);
          }
        });
      });
    }

    otherPriceTypes = _.filter(otherPriceTypes, (item: SegmentFieldItem) => {
      if (item.is_invalid === true) { return false; } // don't display
      if (!_.size(scoreData)) { return true; } // allow all if scorecard is not selected
      // allow price types in the scorecard only
      // @ts-ignore
      return !_.size(_.filter(this.activePriceTypes, { 'item_name': item.item_name }));
    });

    this.dropdownPriceTypes = _.map(otherPriceTypes, (item: any) => {
      item.option = item.item_name;
      item.title = item.title;
      return item;
    });
  }

  findPrimaryPriceSheet(priceSheets: Array<any>): void {
    this.primaryPriceSheet = _.find(priceSheets, ['default', 1]);
  }

  addPriceTypeToDropdown(item: SegmentFieldItem) {
    this.dropdownPriceTypes.push(item);
    this.dropdownPriceTypes = _.orderBy(this.dropdownPriceTypes, 'sequence');
  }
}
